module.exports = __webpack_public_path__ + "static/media/1015195.fee80b88.jpg";